<div class="row account-filter">
  <div class="col-sm-12 col-md-9 col-lg-9 col-xl-10 padding-l0 padding-r0 smallPadRgt0">
    <div class="row search-box-outer xs-full-width">
      <div class="col-4 col-md-4 col-lg-3 padding-r0 borderRight category-drop-outer">
        <div class="category-dropdown material-select">
          <!--<ng-select [items]="filterList"
                     name="ddlCPPSearch"
                     [(ngModel)]="selectedFilter"
                     (ngModelChange)="enableDisableSearchButton()"
                     [virtualScroll]="true"
                     [closeOnSelect]="true"
                     [selectOnTab]="true"
                     [clearable]="false"
                     bindLabel="label"
                     bindValue="column"
                     labelForId="name"
                     [searchable]="false"
                     (change)="retainFilter(null, ' ')">
          </ng-select>-->
          <ng-select name="ddlCPPSearch"
                     [(ngModel)]="selectedFilter"
                     (ngModelChange)="enableDisableSearchButton()"
                     [virtualScroll]="true"
                     [closeOnSelect]="true"
                     [selectOnTab]="true"
                     [clearable]="false"
                     labelForId="name"
                     [searchable]="false"
                     (change)="retainFilter(null, ' ')"
                     data-testid="ddl-cpp-search">
            <ng-option *ngFor="let option of filterList; let i = index;" [value]="option.column">
              <span [attr.data-testid]="'ddl-filter-select_'+option.column">{{option.label}}</span>
            </ng-option>
          </ng-select>
        </div>
      </div>
      <div class="col-8 col-md-8 col-lg-9 padding-l4 padding-r0">
        <div class="material-select account-search">
          <div #productSearch *ngIf="selectedFilter === 'productName'">
            <div class="search-box-outer xs-full-width">
              <div class="search-box wide100">
                <span class="search-icon">
                  <i class="fas fa-search"></i>
                </span>
                <div class="select-container">
                  <input *ngIf="isFromCOIPage" data-testid="ddl-product-name-search" (keyup.enter)="retainFilter(null, ' ');onFilter();" [(ngModel)]="productFilters.Brand"
                    (ngModelChange)="validateProductSearch(productFilters.Brand)" placeholder="Search..." type="text">

                  <app-typeahead *ngIf="!isFromCOIPage" style="top: 17px; left: 42px; position: absolute;width: 100%;" (modelChange)="updatedVal($event); retainFilter(null, ' '); onFilter();" (textLengthDetect)="validateBrand($event)"></app-typeahead>
                </div>
              </div>
            </div>
          </div>

          <ng-select #itemNo name="ddlItemNoSearch" *ngIf="selectedFilter === 'itemNumber'"
                     [items]="itemList"
                     placeholder="Search..."
                     class="custom-select-grower"
                     [multiple]="true"
                     [hideSelected]="true"
                     [(ngModel)]="productFilters.ItemNo"
                     [virtualScroll]="true"
                     bindLabel="value"
                     bindValue="value"
                     [closeOnSelect]="true"
                     [searchFn]="filterSearchFn"
                     (change)="retainFilter(itemNo,'ItemNo')"
                     data-testid="ddl-itemnumber-search">
            <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
              <div class="dropdown-template" [attr.data-testid]="'ddl-itemnumber-option_'+item.value">
                <div class="row">
                  <div class="col-md-8">
                    <p class="name">
                      {{item.value}}
                    </p>
                  </div>
                </div>
              </div>
            </ng-template>
            <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
              <div class="ng-option disabled">
                No data found for "{{searchTerm}}"
              </div>
            </ng-template>
          </ng-select>

          <div *ngIf="selectedFilter=='gtin'">
            <div class="search-box-outer">
              <div class="search-box wide100">
                <span class="search-icon">
                  <i class="fas fa-search"></i>
                </span>
                <div class="select-container">
                  <input data-testid="ddl-gtin-search" (keyup.enter)="retainFilter(null, ' ');onFilter();" [(ngModel)]="productFilters.Gtin"
                         (ngModelChange)="validateProductSearch(productFilters.Gtin)" placeholder="Search..." type="text">
                </div>
              </div>
            </div>
          </div>

          <div *ngIf="selectedFilter=='packageSize'">
            <div class="search-box-outer">
              <div class="search-box wide100">
                <span class="search-icon">
                  <i class="fas fa-search"></i>
                </span>
                <div class="select-container">
                  <input data-testid="ddl-package-size-search" (keyup.enter)="retainFilter(null, ' ');onFilter();" [(ngModel)]="productFilters.PackageSize"
                         (ngModelChange)="validateProductSearch(productFilters.PackageSize)" placeholder="Search..." type="text">
                </div>
              </div>
            </div>
          </div>

          <ng-select #ProductLine name="ddlproductSearch" *ngIf="selectedFilter === 'productLine'"
                     [items]="productLineMasterList"
                     placeholder="Search..."
                     class="custom-select-grower"
                     [multiple]="true"
                     [hideSelected]="true"
                     [(ngModel)]="productFilters.ProductLineList"
                     [virtualScroll]="true"
                     bindLabel="value"
                     bindValue="id"
                     [closeOnSelect]="true"
                     [searchFn]="filterSearchFn"
                     (change)="retainFilter(ProductLine,'ProductLine')"
                     data-testid="ddl-productline-search">
            <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
              <div class="dropdown-template" [attr.data-testid]="'ddl-productline-option_'+item.value">
                <div class="row">
                  <div class="col-md-8">
                    <p class="name">
                      {{item.value}}
                    </p>
                  </div>
                </div>
              </div>
            </ng-template>
            <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
              <div class="ng-option disabled">
                No data found for "{{searchTerm}}"
              </div>
            </ng-template>
          </ng-select>

          <ng-select #activeIngredient name="ddlActiveIngredients" *ngIf="selectedFilter === 'activeIngredients' && !isFromCOIPage"
                     [items]="activeIngredientList"
                     placeholder="Search..."
                     class="custom-select-grower"
                     [multiple]="true"
                     [hideSelected]="true"
                     [(ngModel)]="productFilters.ActiveIngredient"
                     [virtualScroll]="true"
                     bindLabel="value"
                     bindValue="value"
                     [closeOnSelect]="true"
                     [searchFn]="filterSearchFn"
                     (change)="retainFilter(activeIngredient,'ActiveIngredient')"
                     data-testid="ddl-activeIngredients-search">
            <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
              <div class="dropdown-template" [attr.data-testid]="'ddl-activeIngredients-option_'+item.value">
                <div class="row">
                  <div class="col-md-8">
                    <p class="name">
                      {{item.value}}
                    </p>
                  </div>
                </div>
              </div>
            </ng-template>
            <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
              <div class="ng-option disabled">
                No data found for "{{searchTerm}}"
              </div>
            </ng-template>
          </ng-select>

          <div *ngIf="selectedFilter=='activeIngredients' && isFromCOIPage">
            <div class="search-box-outer">
              <div class="search-box wide100">
                <span class="search-icon">
                  <i class="fas fa-search"></i>
                </span>
                <div class="select-container">
                  <input data-testid="ddl-active-ingredient-search" (keyup.enter)="retainFilter(null, ' ');onFilter();" [(ngModel)]="productFilters.ActiveIngredient"
                         (ngModelChange)="validateProductSearch(productFilters.ActiveIngredient)" placeholder="Search..." type="text">
                </div>
              </div>
            </div>
          </div>

          <ng-select #activeIngredient name="ddlVendors" *ngIf="selectedFilter === 'vendor' && !isFromCOIPage"
                     [items]="vendorList"
                     placeholder="Search..."
                     class="custom-select-grower"
                     [multiple]="true"
                     [hideSelected]="true"
                     [(ngModel)]="productFilters.Vendor"
                     [virtualScroll]="true"
                     bindLabel="value"
                     bindValue="value"
                     [closeOnSelect]="true"
                     [searchFn]="filterSearchFn"
                     (change)="retainFilter(vendor,'Vendor')"
                     data-testid="ddl-vendor-search">
            <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
              <div class="dropdown-template" [attr.data-testid]="'ddl-vendor-option_'+item.value">
                <div class="row">
                  <div class="col-md-8">
                    <p class="name">
                      {{item.value}}
                    </p>
                  </div>
                </div>
              </div>
            </ng-template>
            <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
              <div class="ng-option disabled">
                No data found for "{{searchTerm}}"
              </div>
            </ng-template>
          </ng-select>

          <div *ngIf="selectedFilter=='vendor' && isFromCOIPage">
            <div class="search-box-outer">
              <div class="search-box wide100">
                <span class="search-icon">
                  <i class="fas fa-search"></i>
                </span>
                <div class="select-container">
                  <input data-testid="ddl-vender-search" (keyup.enter)="retainFilter(null, ' ');onFilter();" [(ngModel)]="productFilters.Vendor"
                         (ngModelChange)="validateProductSearch(productFilters.Vendor)" placeholder="Search..." type="text">
                </div>
              </div>
            </div>
          </div>

          <ng-select #ProductLine name="ddlproductSearch" *ngIf="selectedFilter === 'productCategory'"
                     [items]="productCategoryMasterList"
                     placeholder="Search..."
                     class="custom-select-grower"
                     [multiple]="true"
                     [hideSelected]="true"
                     [(ngModel)]="productFilters.productCategoryList"
                     [virtualScroll]="true"
                     bindLabel="value"
                     bindValue="id"
                     [closeOnSelect]="true"
                     [searchFn]="filterSearchFn"
                     (change)="retainFilter(ProductCategory,'ProductCatogory')"
                     data-testid="ddl-productCategory-search">
            <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
              <div class="dropdown-template" [attr.data-testid]="'ddl-productCategory-option_'+item.value">
                <div class="row">
                  <div class="col-md-8">
                    <p class="name">
                      {{item.value}}
                    </p>
                  </div>
                </div>
              </div>
            </ng-template>
            <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
              <div class="ng-option disabled">
                No data found for "{{searchTerm}}"
              </div>
            </ng-template>
          </ng-select>
        </div>
      </div>
    </div>
    <div class="row selected-chip xs-pt-5 xs-pb-5 md-pt-10 md-pb-10">
      <div class="col-9 col-md-10 ">
        <div>
          <mat-chip-set>
            <mat-chip selected *ngFor="let filterValue of filterValueList">
              {{filterValue}}
              <a href="Javascript:void(0);" (click)="clearFilter(filterValue)">
                <i class="fas fa-times text-right"></i>
              </a>
            </mat-chip>
          </mat-chip-set>
        </div>
      </div>
      <div class="col-3 col-md-2 text-right padding-r0" *ngIf="filterValueList.length > 0">
        <a href="Javascript:void(0);" data-testid="ddl-cpp-clear-all-filter" class="clearAll" (click)="removeAllFilter()">Clear All</a>
      </div>
    </div>
  </div>

  <div class="col-sm-12 col-md-3 col-lg-3 col-xl-2 search-btn-outer text-center padding-r0 padding-l0">
    <div class="search-btn">
      <button data-testid="ddl-product-search" mat-raised-button class="btns md-mt-15 xs-mt-0" color="primary" [disabled]="disableFilterBtn" (click)="onFilter()">Search</button>
    </div>
  </div>
</div>
